import React from "react";
import { default as MuiPagination } from "@mui/material/Pagination";

function Pagination(props) {
  return <MuiPagination {...props} />;
}

export default Pagination;
